import React from "react";
import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";

interface IProps {
  onClick?: any;
  btnClassName?: string;
  disabled?: boolean;
}

const TemplateButton: React.FC<IProps> = ({
  onClick,
  btnClassName,
  disabled = false,
}) => {
  return (
    <div>
      <button
        className={`hover:scale-90 transition duration-500 bg-tranparent mr-2 ml-auto border-secondary shadow-md hover:bg-secondary
           text-secondary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full
            hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary focus:ring-opacity-70${btnClassName}`}
        onClick={onClick}
        disabled={disabled}
      >
        <ArrowDownCircleIcon className="h-4 w-4 mr-2" />
        Template
      </button>
    </div>
  );
};

export default TemplateButton;
